<div class="streaming-logo-fallback">{{ streamingPlatform.name }}</div>
